// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from "i18next-browser-languagedetector";

// Import translations
import translationEN from './locales/en/translation.json'; // English
import translationES from './locales/es/translation.json'; // Spanish

const options = {
  // order and from where user language should be detected
  order: ['path'],

  lookupFromPathIndex: 0
}

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};
i18n
.use(detector)
.use(initReactI18next)
.init({
  resources,
  detection: options,
  fallbackLng: "en", // use en if detected lng is not available
  keySeparator: false, // Allow for nested translations without using dots
  interpolation: {
    escapeValue: false,
  },
});
export default i18n;